<template>
  <div class="main-layout">
    <top-bar></top-bar>
    <div class="body-content" v-if="!$route.meta.noSideBar">
      <div :class="isFold ? 'content-wrap' : 'content-wrap fold'">
        <router-view id="main-page-scroll-id" class="main-page-scroll"></router-view>
      </div>
      <side-bar @fold="changeHandle"></side-bar>
    </div>
    <div class="body-content" v-else>
      <router-view></router-view>
    </div>
    <Contact></Contact>
    <el-dialog
      title="提示"
      :visible="dialogVisible"
      width="350px"
      class="business-dialog"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
      @close="handleCancle">
      <div style="display: flex">
        <i class="iconfont icon-tip-warning"></i>
        <p class="p">为了更好的支撑合作伙伴与华夏云网的业务往来，完成交易、付款等流程，需要合作伙伴完善银行信息、税务信息等商业信息。</p>
      </div>
      <div style="text-align: right; margin-top: 20px">
        <el-button @click="cancel">取消</el-button>
        <el-button type="primary" @click="toBusiness">商业信息认证</el-button>
        
      </div>
    </el-dialog>
  </div>
</template>

<script>
import TopBar from "@/modules/main/view/layout/TopBar";
import SideBar from "@/modules/main/view/layout/SideBar";
import Contact from "@/components/Contact";
// import Protocol from "@/modules/doc/view/protocol/Index.vue";
import {portalUrl} from "@domain";
// import { utils } from "@/utils/utils";
// import { mainApi } from "@main/services";
import { accountApi } from "@user-center/account/services";
import { mapGetters } from "vuex";
export default {
  components: { TopBar, SideBar, Contact },
  data() {
    return {
      isFold: true,
      // dialogVisible:false,
      // showErrorTips:false,
      agreement:false,
       title: "协议确认",
      protocolTrue: false,
      dialogVisible: false,
      isMaster: false, //主账号显示
      protocolContent: [], //协议内容
      protocolIds:[], // 协议ID集合
    };
  },
  computed: {
    ...mapGetters(["userInfo","planTypeList"]),
  },
  created() {
    //  this.isMaster = this.userInfo && this.userInfo.isMaster;
    // this.isMaster&&this.reSign(); //主账号才调用
  },
  mounted(){
    // 判断是否已经加入计划
    if(this.planTypeList.length > 0) {
      this.showDialog()
    }
  },
  methods: {
    changeHandle(val) {
      this.isFold = val;
    },
    // showDialog(){
    //   mainApi.querycloudmarketprotocol({}).then(res=>{
    //     if(res && res.retCode === "0000"){
    //       this.protocolContent = res.obj && res.obj.signProtocol || [];
    //       this.protocolIds = res.obj && res.obj.protocolIds || [];

    //       if(this.protocolContent.length == 0){
    //         this.jumpCloudCenter();
    //       }
    //       this.$nextTick(()=>this.dialogVisible = this.protocolContent.length > 0)
    //     }
    //   })
    // },
     //判断是否重签
    // reSign() {
    //   mainApi.isResign().then((res) => {
    //     if (res&&res.retCode === "0000"&&res.obj) {
    //       this.protocolContent = res.obj.reSignProtocol;
    //       this.$nextTick(()=>this.dialogVisible = res.obj.reSign)
    //     }
    //   });
    // },
    //协议内容
    // goProtocolDatail(row) {
    //   if(row.protocolHtmlUrl){
    //     window.open(row.protocolHtmlUrl);
    //   }
    // },
    //保存协议
    // trueSubmit() {
    //   mainApi.saveResign(this.protocolIds).then((res) => {
    //     if (res&&res.retCode === "0000") {
    //       this.$message.success("协议重签成功");
    //       this.dialogVisible = false;
    //       this.jumpCloudCenter();
    //     }
    //   });
    // },
    /** 
     *  新增商业信息认证暂时需要的弹窗需求 
     * 历史的用户，在做任何操作时，弹窗提示商业信息认证，认证提交审核后就不继续弹窗
     */
    showDialog(){
      // const visited=window.sessionStorage.getItem("businessDialog")
      if(this.planTypeList.find(item=>item.partnerType==='0'&&item.joinPlanFlag)){
        accountApi.queryBusinessStatu().then((res) => {
          //1 待审核 2 已完成 3 已驳回
          if(res&&res.result&&res.obj&&!res.obj.length&&(this.$route.path!=="/user-center/account/addBusinessInfo")){
            this.dialogVisible=true
          }
        })
      }
    },
    handleCancle() {
      this.dialogVisible = false;
    },
    goPortal() {
      window.location.href=`${portalUrl}`;
    },
    toBusiness(){
      // window.sessionStorage.setItem("businessDialog",1);
      this.dialogVisible = false;
      this.$router.push("/user-center/account/authentication");
    },
    cancel(){
      // window.sessionStorage.setItem("businessDialog",1);
      this.dialogVisible = false;
    }
  }
};
</script>

<style lang="scss" scoped>
.main-layout {
  min-width: 1356px;
  // min-width: 1366px;
  .body-content {
    width: 100%;
    overflow: hidden;
    background: #f4f7fc;
    height: calc(100vh - 50px); //delete by zjj
    //min-height: 500px;
    .content-wrap {
      //overflow-y: auto;
      float: right;
      width: calc(100% - 220px);
      // height: 101%;
    }
    .content-wrap.fold {
      float: right;
      width: calc(100% - 48px);
      transition: all 0.1s ease, 0.1s ease;
    }

    .main-page-scroll {
      // height: 101%;
      overflow-y: auto;
    }
  }
  &>>>.common-dialog-content{
    height: 400px;
    overflow-y: auto;
    border:1px solid#cdc9c9;
    .page-box{
      .bread-crumb-outer{
        display: none;
      }
      .page-content{
        height: 100%;
        margin: 0;
      }
    }
  }
  .common-protocol-footer{
    .footer-div{
      margin: 20px 0 10px 0;
      text-align: left;
      .error-tips{
        font-size: 12px;
        color: transparent;
        margin-top: 2px;
        &.show{
          color:#f00;
        }
      }
    }
  }
}
.business-dialog >>>{
  .p{
    margin-left: 8px;
            font-size: 12px;
            color: #212a40;
            line-height: 18px;
  }
}
  

</style>


// WEBPACK FOOTER //
// src/modules/main/view/layout/MainLayout.vue